import { STEPS } from '../store/loanApplicationSlice';

/**
 * Borrower-facing journey shown during the conversational apply flow.
 * Wording is intentional plain language — not internal status labels.
 */
export const APPLY_MILESTONES = [
  {
    id: 'program',
    label: 'Find your loan program',
    description:
      'We learn about your goals and situation so we can point you to the loan path that fits best.',
  },
  {
    id: 'application',
    label: 'Build your application',
    description:
      'You complete as much of your file as we can shape to that program — the details that matter for your loan type.',
  },
  {
    id: 'underwriting',
    label: 'Underwriting review',
    description:
      'We review your file for strengths, gaps, and what a lender will want to see before you go to market.',
  },
  {
    id: 'lender',
    label: 'Connect with a lender',
    description:
      'When you are ready, you package what you have built and submit to a lender on your timeline.',
  },
];

export const APPLY_MILESTONES_PANEL_TITLE = 'Your path';

/**
 * @param {object} params
 * @param {number} params.currentStep — loanApplicationSlice STEPS value
 * @param {string} [params.v1Phase] — v1 triage | fields | documents | complete | exit
 * @param {boolean} [params.hasRecommendedProduct]
 * @returns {number} Active milestone index (0–3)
 */
export function getActiveApplyMilestoneIndex({
  currentStep,
  v1Phase,
  hasRecommendedProduct = false,
}) {
  if (currentStep >= STEPS.LENDER_NETWORK) return 3;
  if (
    currentStep >= STEPS.UNDERWRITING_PICKER
    || currentStep === STEPS.UNDERWRITING
    || currentStep === STEPS.HUMAN_UNDERWRITING
  ) {
    return 2;
  }
  if (currentStep >= STEPS.APPLICATION) return 1;

  if (v1Phase === 'fields' || v1Phase === 'documents' || v1Phase === 'complete') {
    return 1;
  }
  if (hasRecommendedProduct && v1Phase && v1Phase !== 'triage') {
    return 1;
  }

  return 0;
}
